import React from 'react'
import Grid from '../../components/Grid'
import styled from 'styled-components'
import { SCREEN_SIZE } from '../../lib/Media'
import OFFER_OLD from '../../components/Vouchers/assets/offer-old.svg'
import { GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'
import { AMP_EVENT_NAME } from '../../lib/amplitude'
import SvgArrowRight from '@ntuctech/devex-tangram/Icon/SvgArrowRight'

const VoucherContainer = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  ${SCREEN_SIZE.From.Tablet} {
    padding: 0 2rem 2rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    padding: 0 2.5rem 2.5rem;
  }
`

const StyledVoucherCard = styled.div`
  height: 5.5rem;
  background: #ffffff;
  margin: 0.25rem 0;
  border-radius: 0.25rem;
  display: flex;
  overflow: hidden;
  ${SCREEN_SIZE.Below.Tablet} {
    border: 1px solid #eaeaea;
  }
  ${SCREEN_SIZE.From.Tablet} {
    border: 0.063rem solid #eaeaea;
  }
`

const StyledVoucherIcon = styled.img`
  width: 3.75rem;
  height: 3.75rem;
  background: #ffffff;
  margin: 1rem 0.5rem;
`

const ContentContainer = styled.div`
  padding: 0.75rem 0.5rem;
  gap: 0.25rem;
`

const StyledTitle = styled.div`
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  height: 1.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333333;
`

const StyledSubTitle = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  height: 1.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333333;
`

const StyledLink = styled.div`
  cursor: pointer;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #1454b8;
`

const StyledButtonGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const StyledContainerGrid = styled(Grid)`
  &:hover {
    cursor: pointer;
  }
`

const UnionContainerTop = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #f3f5f7;
  position: absolute;
  margin-top: -0.5rem;
  ${SCREEN_SIZE.From.Tablet} {
    border: none;
    background-color: #ffffff;
    box-shadow: 0 0.0625rem rgb(0 0 0 / 9%);
  }
`

const UnionContainerBottom = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #f3f5f7;
  margin-top: 5rem;
  position: absolute;
  ${SCREEN_SIZE.From.Tablet} {
    border: none;
    background-color: #ffffff;
    box-shadow: 0 0.0625rem rgb(0 0 0 / 9%);
    transform: rotate(180deg);
  }
`

const deeplink = 'fairprice://loyalty/vouchers/campaigns?id=sec-2025'

const EveryDaySaveCard = ({
  cardData,
  setOpen,
  isMobile,
  isTablet,
  GA,
  track,
}) => {
  const handleClick = (source, item) => {
    setTimeout(() => {
      window.location = deeplink
    }, 25)
    setOpen(true)
    GA.track(
      GA.eventsDataset[
        source === 'view'
          ? GA.TRACKER_CONSTANTS.ON_VIEW_DETAILS_CLICK
          : GA.TRACKER_CONSTANTS.ON_SAVE_CLICK
      ]
    )
    track({
      [GEV.AMPLITUDE_EVENT_NAME]:
        source === 'save'
          ? AMP_EVENT_NAME.SEC_SAVED_CLICKED
          : AMP_EVENT_NAME.SEC_VIEW_CLICKED,
      [GEV.AMPLITUDE_VERTICAL]: 'rewards',
      [GEV.AMPLITUDE_EVENT_TYPE]: AMP_EVENT_NAME.VOUCHER_EVENT_PROPERTY,
      [GEV.AMPLITUDE_CTA_LOCATION]: `rewards | ${item?.detail?.title}`,
      [GEV.AMPLITUDE_CTA_SUBLOCATION_SECTION_TYPE]: 'null',
      [GEV.VOUCHER_CODE_VOUCHER_CODE]: item?.code,
      [GEV.AMPLITUDE_VOUCHER_TYPE]: item?.code,
      [GEV.AMPLITUDE_OFFER_ID]: item?.id,
      [GEV.SEC_OFFER_VERTICAL]: 'OG',
    })
  }

  return (
    <VoucherContainer>
      <Grid container compact>
        {cardData.map((item, index) => {
          return (
            <StyledContainerGrid
              xs={isMobile ? 12 : isTablet ? 6 : 4}
              key={index}
              data-testid={`sec-voucher-card-${index}`}
              onClick={() => handleClick('view', item)}
            >
              <StyledVoucherCard>
                <Grid xs={2}>
                  <StyledVoucherIcon src={item.imgUrls?.logo || OFFER_OLD} />
                </Grid>
                <Grid item xs={1}>
                  <UnionContainerTop />
                  <UnionContainerBottom />
                </Grid>
                <Grid item xs={6}>
                  <ContentContainer>
                    <StyledTitle>{item.detail?.title}</StyledTitle>
                    <StyledSubTitle>{item.detail?.subTitle}</StyledSubTitle>
                    <StyledLink data-testid={`view-detail-${index}`}>
                      View detail
                    </StyledLink>
                  </ContentContainer>
                </Grid>
                <StyledButtonGrid item xs={3}>
                  <SvgArrowRight size="m" color="#999999" className="desktop" />
                </StyledButtonGrid>
              </StyledVoucherCard>
            </StyledContainerGrid>
          )
        })}
      </Grid>
    </VoucherContainer>
  )
}

export default EveryDaySaveCard
